import {localeServerSideProps} from "@i18n/pages";
import LocationsIndex from "@page-containers/locations";
import {I18nNamespace} from "@i18n";

export const getServerSideProps = localeServerSideProps([I18nNamespace.MAIN, I18nNamespace.DB]);

export default LocationsIndex;
